export default __webpack_public_path__ + "static/media/yellow_shadown_circle.dc17467b.svg";